import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputNumber, InputSwitch, InputPicklist, InputRating } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './transactiondetail-model';  //editable..
import ProductList from '../product/product-list.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactiondetailView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                endPointFilter={Model.endPointFilter2} model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} readOnly/>
                <InputPicklist name='product' label='Product' value={this.state.datarow.product} caption={this.state.datarow.productCaption} readOnly/>
                <InputMoney name='price' label='Price' value={this.state.datarow.price} readOnly/>
                <InputNumber name='number' label='Qty' value={this.state.datarow.qty} readOnly/>
                <InputMoney name='value' label='Total' value={this.state.datarow.value} readOnly/>
                {this.state.datarow.productProducttypeType === 'events' &&
                <>
                {this.state.datarow.productSchedule?.length > 0 &&
                <InputPicklist name='schedule' label='Schedule' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} readOnly/>
                }
                <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} readOnly/>            
                </>
                }
                {this.state.datarow.productProductLength > 0 &&
                    <ProductList history={this.props.history} caption='Sub Product' parentId={this.state.datarow.product} actions={[]} disableBackButton/>
                }
                {this.state.datarow.transactionStatus === 'approved' &&
                <>
                <InputRating name='rating' label='Rating' value={this.state.datarow.rating} size='large' readOnly/>
                <InputMultiline name='comment' label='Comment' value={this.state.datarow.comment} readOnly/>
                </>
                }
              </BaseView>
        );
    }
}